<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  {{data.message}}
</div>
<div class="button-row">
  <button [mat-dialog-close]="true" class="button-blueGDPR">
    {{ data.confirm }}
  </button>
</div>
